// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","StrollerBoxWidget":"beu_a bhr_tr","StrollerBoxWidget__imageCounselling":"beu_b bhr_kg"};